import React from 'react';

import { BackButton } from '../../../common/button/back-button/BackButton';
import { BreadCrumbTrail } from '../../../common/breadcrumb-trail/BreadcrumbTrail';
import { ParticipantReviewGeneralTab } from './ParticipantReviewGeneralTab';

import './ParticipantReviewCreate.css';

export const ParticipantReviewCreate = ({
  context,
  setContext,
  navigateTo,
  showToaster,
  setSpinnerText,
  toolTipsEnabled,
  navigateToWith,
}) => {
  return (
    <div className="clients-create-container">
      <div className="clients-create-header-container">
        <BackButton onClick={() => navigateTo('participantReviewsTable')} />
        <h2>Create New Review</h2>
      </div>

      <div className="wizard-content-container">
        <div className="wizard-main-content-container">
          <div className="clients-create-container">
            <div className="clients-create-tab-container">
              <div className="clients-create-tab general active-tab">General</div>
            </div>

            <div className={'clients-create-tab-content participantReviewCreateGeneral'}>
              <ParticipantReviewGeneralTab
                context={context}
                setContext={setContext}
                review={{}}
                navigateTo={navigateTo}
                navigateToWith={navigateToWith}
                toolTipsEnabled={toolTipsEnabled}
                setSpinnerText={setSpinnerText}
                showToaster={showToaster}
                editMode={false}
              />
            </div>
          </div>
        </div>

        <div className="wizard-breadcrumb-container">
          <BreadCrumbTrail context={context} navigateTo={navigateTo} />
        </div>
      </div>
    </div>
  );
};
